import { DatabaseCode, toDatabaseCode } from "./database-code";

export type SystemProcessTriggerType = DatabaseCode;

const manual: SystemProcessTriggerType = {
  code: "MANUAL",
  displayValue: {
    id: "common.entity.systemprocesstriggertype.manual",
    defaultMessage: "Manual",
  },
};

const scheduled: SystemProcessTriggerType = {
  code: "SCHEDULED",
  displayValue: {
    id: "common.entity.systemprocesstriggertype.scheduled",
    defaultMessage: "Scheduled",
  },
};

const api: SystemProcessTriggerType = {
  code: "API",
  displayValue: {
    id: "common.entity.systemprocesstriggertype.api",
    defaultMessage: "API",
  },
};

const event: SystemProcessTriggerType = {
  code: "EVENT",
  displayValue: {
    id: "common.entity.systemprocesstriggertype.event",
    defaultMessage: "Event",
  },
};

const retry: SystemProcessTriggerType = {
  code: "RETRY",
  displayValue: {
    id: "common.entity.systemprocesstriggertype.retry",
    defaultMessage: "Retry",
  },
};

export const systemProcessTriggerType = {
  manual,
  scheduled,
  api,
  event,
  retry,
};

export const systemProcessTriggerTypes = Object.values(systemProcessTriggerType);

export const toSystemProcessTriggerType = (
  code: string
): SystemProcessTriggerType =>
  toDatabaseCode(code, systemProcessTriggerTypes);

export const toSystemProcessTriggerTypeSafely = (
  code: string | undefined
): SystemProcessTriggerType | undefined =>
  code ? toDatabaseCode(code, systemProcessTriggerTypes) : undefined;
